import { fetchMobileApps } from 'modules/mobileApps/actions';
import { selectMobileApps } from 'modules/mobileApps/selectors';
import { AppPlatform } from 'modules/mobileApps/types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHasApps, sortMobileAppsByName } from './DestinationSelectorModal.utils';

const { IOS, ANDROID, WEB, OTT } = AppPlatform;

export const useDestinationAppsAndWebsites = () => {
  const dispatch = useDispatch();

  const allAppsAndWebsites = useSelector(selectMobileApps);

  const mobileApps = sortMobileAppsByName(
    allAppsAndWebsites?.filter((app) => app.platform === IOS || app.platform === ANDROID),
  );

  const websites = sortMobileAppsByName(allAppsAndWebsites?.filter((app) => app.platform === WEB));
  const mobileAppsAndWebsites = sortMobileAppsByName([...mobileApps, ...websites]);
  const rokuApps = sortMobileAppsByName(allAppsAndWebsites?.filter((app) => app.platform === OTT));

  const hasWebsites = getHasApps(websites);
  const hasRokuApps = getHasApps(rokuApps);
  const hasMobileApps = getHasApps(mobileApps);

  useEffect(() => {
    dispatch(fetchMobileApps());
  }, []);

  return {
    allAppsAndWebsites,
    mobileAppsAndWebsites,
    mobileApps,
    websites,
    rokuApps,
    hasMobileApps,
    hasWebsites,
    hasRokuApps,
  };
};
